// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6358":"0109b5c2b037aa67","8501":"b224dda0e3c05f72"}[chunkId] + ".css";
};